import { QRCodeSVG } from "qrcode.react";

export const DownloadQrCard = ({ testId }) => {
    const downloadUrl = "https://meetwithlunar.com/download";

    return (
        <div
            data-testid={testId}
            aria-label="Scan to download Lunar on your phone"
            className="hidden h-[72px] items-center gap-2.5 rounded-2xl border border-[#C2C0B8] bg-[#F9F8F4] p-2.5 lg:flex"
        >
            <QRCodeSVG value={downloadUrl} size={52} bgColor="#F9F8F4" fgColor="#2C3618" level="M" marginSize={1} />
            <span className="text-left text-[10px] font-bold uppercase leading-snug tracking-[0.14em] text-[#5C5F58]">
                Scan to
                <br />
                download
            </span>
        </div>
    );
};
